import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconComponent } from '@mode/capra';
import { ToastService } from './toast.service';
import { ToastComponent } from './toast/toast.component';
import { MessageToastComponent } from './message-toast/messsage-toast.component';

@NgModule({
  declarations: [MessageToastComponent, ToastComponent],
  imports: [CommonModule, IconComponent],
  providers: [ToastService],
  exports: [ToastComponent],
})
export class SharedUtilToastModule {}
